import Vue from 'vue'

import App from './AppNewIarc.vue'
import router from './router'

import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n.js'
import { Trans } from './plugins/Translation.js'
import MobileDetect from 'mobile-detect'

// global 
import store from '@/subsites/today/store.js'


Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
//Vue.config.productionTip = false;
Vue.config.devtools = true ;

import ConstProject from '@/subsites/today/const.js'

import BarsConf from '@/subsites/today/conf/visualisations/Bars.json'
import TablesConf from '@/subsites/today/conf/visualisations/Tables.json'
import PieConf from '@/subsites/today/conf/visualisations/Pie.json'
import MapsConf from '@/subsites/today/conf/visualisations/Maps.json'
import PlotsConf from '@/subsites/today/conf/visualisations/Plots.json'
import BarsPrevalenceConf from '@/subsites/today/conf/visualisations/BarsPrevalence.json'
import PyramidConf from '@/subsites/today/conf/visualisations/Pyramid.json'
import TreemapConf from '@/subsites/today/conf/visualisations/Treemap.json'

store.commit('setConst', ConstProject)
store.commit('setConf', {
	tables : TablesConf ,
	bars : BarsConf , 
	pie : PieConf , 
	maps : MapsConf , 
	plots : PlotsConf , 
	bars_prev : BarsPrevalenceConf , 
	pyramid : PyramidConf , 
	treemap : TreemapConf
}) ; 

store.commit('setDevice' , {
	md : new MobileDetect( navigator.userAgent ) , 
	window : { w : $(window).width() , h : $(window).height() }
})

var Default = {
	width : 1140 , 
	height : 1683 , 
	width_pie : 764 - 20 ,  
	pie_items : 5 , 
	pie_margin : 50 , 
	registries : [] , 
	third_page : false , 
	extra_registries : '' ,
	title_font_size : ''
} ; 

let url_api 		= process.env.VUE_APP_API  ; 
let base_url_api 	= url_api ;
let data_version = ConstProject.data_version ; 

let uri     = window.location.search.substring(1); 
let folders = window.location.pathname.split('/') ; 
let params  = new URLSearchParams(uri);

// console.info("params.get('data_version')",params.get('data_version'))
if ( params.get('data_version') != '' && params.get('data_version') != null ) data_version = params.get('data_version') ; 
if ( folders.includes('today_ps27')) {
	data_version = '2022ps' ;  
	store.commit('setVersion', data_version )

}

url_api = url_api.replace('[vdb]',data_version) ; 

// 
// console.log("url_api + 'meta/cancers/all/' ",url_api + 'meta/cancers/all/' ) ; 

let promises 		= [
    // cancer site list 
    axios.get( url_api + 'meta/cancers/all/' ) ,
    // pops list 
    axios.get( url_api + 'meta/populations/all/' ),
    // methods
    axios.get( url_api + 'meta/method/all/' )

] ; 


// pre load cancer one time and commit them to store
axios.all( promises )

	.then( axios.spread(( cancers_promise , populations_promise , methods_promise ) => {

		// specific filtering of dictionnaries data
		let cancer_sites_list = cancers_promise.data.filter( f => {
			return true ; 
			// return !ConstProject.exclude_cancer_sites.includes(f.cancer) ; 
		}).map( cancer => {
			// cancer.label = cancer.short_label ;
			return cancer ; 
		})
			
		let populations_list = Object.values(populations_promise.data)
		
		store.commit('setDictionnay', {
			cancers_promise : cancer_sites_list ,
			populations_promise : populations_list , 
			methods_promise : methods_promise.data
		}) ; 

		store.commit('setApi', url_api )

		new Vue({
		  router,
		  store,
		  i18n,
		  BootstrapVue,
		  render: h => h(App)
		}).$mount('#app')

		Vue.filter('formatRate', function(value) {
			if (value == 'NA') return value ; 
		  	return formatRate(value);
		});

	}))
    // eslint-disable-next-line
    .catch( error => {
        console.error("Error catched",error) ; 
        this.error = true
    })
    .finally(() => {
    })

Vue.filter('formatRate__', function(value) {
  return formatRate__(value);
});

